import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, createMigrate } from 'redux-persist';

import balanceReducer from '../slices/contract-balance-slice';
import settingsReducer from '../slices/settings-slice';
import golisBalanceReducer from '../slices/golis-balance-slice';
import adminTransactionsReducer from '../slices/admin-transactions-slice';
import dashboardReducer from '../slices/admin-dashboard-slice';
import pricesReducer from '../slices/prices-slice';

// ----------------------------------------------------------------------

const migrations = {
  // version 1: wipe previously persisted settings (bank poller status) —
  // stale authenticated:true could mask a real auth failure on next session.
  // All state is re-hydrated from the socket on connect.
  1: (state) => ({
    ...state,
    settings: undefined,
    contractBalance: undefined,
    golisBalance: undefined,
    adminTransactions: undefined,
    dashboard: undefined,
  }),
  // version 2: prices slice added (live from the socket, never persisted).
  2: (state) => ({
    ...state,
    prices: undefined,
  }),
};

// Nothing is persisted. All slices are live-updated via the admin socket.
// Do NOT add any slice to this whitelist without a security review —
// this store contains platform-wide financial and transaction data.
export const adminPersistConfig = {
  key: 'admin',
  storage,
  keyPrefix: 'redux-',
  version: 2,
  migrate: createMigrate(migrations, { debug: false }),
  whitelist: [],
};

const adminAppReducer = combineReducers({
  contractBalance: balanceReducer,
  settings: settingsReducer,
  golisBalance: golisBalanceReducer,
  adminTransactions: adminTransactionsReducer,
  dashboard: dashboardReducer,
  // Live token prices (socket `prices` broadcast) — used for gas-in-USD
  // estimates in the payout dialogs.
  prices: pricesReducer,
});

const adminRootReducer = (state, action) => {
  if (action.type === 'RESET_ADMIN_STORE') {
    return undefined;
  }

  return adminAppReducer(state, action);
};

export const persistedAdminReducer = persistReducer(adminPersistConfig, adminRootReducer);

export default adminRootReducer;
